/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterConstraintBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return ParameterConstraintBase.fixupPrototype; }

    static newInstance(model: Partial<ParameterConstraintBase>): ParameterConstraintBase {
        let obj = Object.assign(new ParameterConstraintBase(), model);
        ParameterConstraintBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterConstraintBase>): ParameterConstraintBase {
        if (!model) return null;
        return ParameterConstraintBase.newInstance(<ParameterConstraintBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterConstraintBase) {
        if (!obj) return;

        models.ParameterConstraintBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterConstraintBase): boolean {
        switch (obj.__type)
        {
            case "ParameterConstraintForAllowedValues":
                Object.setPrototypeOf(obj, models.ParameterConstraintForAllowedValues.prototype);
                break;
            case "ParameterConstraintForLength":
                Object.setPrototypeOf(obj, models.ParameterConstraintForLength.prototype);
                break;
            case "ParameterConstraintForNumericRange":
                Object.setPrototypeOf(obj, models.ParameterConstraintForNumericRange.prototype);
                break;
            case "ParameterConstraintForRegexPattern":
                Object.setPrototypeOf(obj, models.ParameterConstraintForRegexPattern.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ParameterConstraintBase)[] {
        return [
            models.ParameterConstraintForAllowedValues,
            models.ParameterConstraintForLength,
            models.ParameterConstraintForNumericRange,
            models.ParameterConstraintForRegexPattern,
        ];
    }

    fixupFields() {
    }

    /**
     * Description of the parameter's constraint field.
     */
    description: string;

}
